import { TimeRangePickerProps } from 'antd'
import dayjs from 'dayjs'
import { ColumnFilterItem } from 'antd/lib/table/interface'

export const rangePresets: TimeRangePickerProps['presets'] = [
  { label: 'Today', value: [dayjs(), dayjs()] },
  { label: 'Yesterday', value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
  { label: 'Last week', value: [dayjs().add(-7, 'd'), dayjs()] },
  { label: 'Last month', value: [dayjs().add(-31, 'd'), dayjs()] },
]

export const convertOrderStatus = (status: string): string => {
  switch (status) {
    case 'ORDER_STATUS_INVALID':
      return 'invalid'
    case 'ORDER_STATUS_PENDING':
      return 'pending'
    case 'ORDER_STATUS_COMPLETED':
      return 'completed'
    case 'ORDER_STATUS_CANCELLED':
      return 'cancelled'
    case 'ORDER_STATUS_PAID':
      return 'paid'
    case 'ORDER_STATUS_PROCESSING':
      return 'processing'
    case 'ORDER_STATUS_REJECTED':
      return 'rejected'
    case 'ORDER_STATUS_EXPIRED':
      return 'expired'
    case 'ORDER_STATUS_ERROR':
      return 'error'
    default:
      return status
  }
}

export const statusFilter: ColumnFilterItem[] = [
  { value: 'ORDER_STATUS_PENDING', text: 'pending' },
  { value: 'ORDER_STATUS_COMPLETED', text: 'completed' },
  { value: 'ORDER_STATUS_CANCELLED', text: 'cancelled' },
]

export const backendStatusFilter: ColumnFilterItem[] = [
  { value: 'ORDER_STATUS_PENDING', text: 'pending' },
  { value: 'ORDER_STATUS_COMPLETED', text: 'completed' },
  { value: 'ORDER_STATUS_CANCELLED', text: 'cancelled' },
  { value: 'ORDER_STATUS_PAID', text: 'paid' },
  { value: 'ORDER_STATUS_PROCESSING', text: 'processing' },
  { value: 'ORDER_STATUS_REJECTED', text: 'rejected' },
  { value: 'ORDER_STATUS_EXPIRED', text: 'expired' },
]

export const backendInstallmentFilter: ColumnFilterItem[] = [
  { value: 'true', text: 'With Installment' },
  { value: 'false', text: 'Without Installment' },
]

export enum paymentMethod {
  NOVA_WALLET = 'NOVA Wallet',
  AUTO_REDUCTION_ORDER = 'Auto reduction order',
}
